import { render, staticRenderFns } from "./HitCount.vue?vue&type=template&id=127c55bc&"
import script from "./HitCount.vue?vue&type=script&lang=ts&"
export * from "./HitCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports